export const tierListItemTypeManual: { baseType: string, tierListItemType: string }[] = [
  { baseType: 'Breach Splinter', tierListItemType: 'Breach' },
  { baseType: 'Breachstone', tierListItemType: 'Breach' },
  { baseType: 'Simulacrum Splinter', tierListItemType: 'Delirium' },
  { baseType: 'Simulacrum', tierListItemType: 'Delirium' },
];
